<div class="lang-selector" [class.compact]="compact()" [class.bare]="bare()" [class.open]="isOpen()">
  @if (showTitle() && !compact()) {
    <h3>{{ 'FOOTER.LANGUAGE' | translate }}</h3>
  }

  <button class="lang-trigger" (click)="toggleDropdown()" type="button" aria-haspopup="listbox" [attr.aria-expanded]="isOpen()">
    <span class="flag">{{ currentLang().flag }}</span>
    @if (!compact()) {
      <span class="name">{{ currentLang().name }}</span>
    } @else {
      <span class="code">{{ currentLang().code | uppercase }}</span>
    }
    <svg class="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M6 9l6 6 6-6"/>
    </svg>
  </button>

  @if (isOpen()) {
    <ul class="lang-dropdown" role="listbox">
      @for (lang of languages; track lang.code) {
        <li
          role="option"
          [class.active]="lang.code === currentLang().code"
          (click)="selectLanguage(lang)">
          <span class="flag">{{ lang.flag }}</span>
          <span class="name">{{ lang.name }}</span>
          @if (lang.code === currentLang().code) {
            <svg class="check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
              <path d="M5 12l5 5L20 7"/>
            </svg>
          }
        </li>
      }
    </ul>
  }
</div>
